<template>
  <div class="tree-wrapper">
    <el-tree
      v-loading="treeLoading"
      ref="tree"
      :data="treeData"
      node-key="id"
      :default-expanded-keys="[0, -1]"
      :expand-on-click-node="false"
      :highlight-current="true"
      :props="{ children: 'children', label: 'name' }"
      @node-click="handleNodeClick"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.label }}</span>
        <span>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link" style="cursor: pointer">
              <i class="el-icon-s-tools"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="handleInitCommand('add', data)">添加</el-dropdown-item>
              <el-dropdown-item :command="handleInitCommand('update', data)">修改</el-dropdown-item>
              <el-dropdown-item :command="handleInitCommand('delete', data)">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </span>
    </el-tree>

    <menu-dialog ref="menuDialogRef" @handle-get-tree-data="handleGetSystemMenu" />
  </div>
</template>

<script>
import MenuDialog from '../menuMng/MenuDialog.vue'
import Services from '@/services/api/backstage'

export default {
  props: {
    // 是否查询所有内容 =》 授权页需要查询全部内容
    queryAll: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MenuDialog,
  },
  data() {
    return {
      treeLoading: false,
      treeData: [],
      defaultKey: null,
      lastMenu: null,
    };
  },
  async mounted() {
    await this.handleGetSystemMenu()
    this.$refs.tree.setCurrentKey(this.queryAll ? this.treeData[0].id : this.treeData[0].children[0].id)
    this.$emit('handle-get-list', this.queryAll ? this.treeData[0] : this.treeData[0].children[0])
  },
  methods: {
    async handleGetSystemMenu() {
      try {
        this.treeLoading = true
        const { data } = await Services.apiGetSystemTree()
        this.treeData = data.data
      } catch (error) {
        console.log(error)
      } finally {
        this.treeLoading = false
      }
    },

    handleNodeClick(data) {
      this.$emit('handle-get-list', data)
    },

    handleCommand({ command, data }) {
      switch (command) {
        case 'add':
          this.handleAddMenu(data)
          break;
        case 'update': 
          this.handleEditMenu(data)
          break;
        default:
          this.handleDelete(data)
          break;
      }
    },

    handleInitCommand(command, data) {
      return {
        command,
        data,
      }
    },
    
    handleAddMenu(data) {
      this.handleGetLastMenu(data)
      this.$refs.menuDialogRef.handleOpen(data, this.lastMenu)
    },

    handleEditMenu(data) {
      this.$refs.menuDialogRef.handleEdit(data)
    },

    handleGetLastMenu(data) {
      const { name, parentId, id } = data
      this.lastMenu = {
        name,
        parentId,
        id,
      }
    },

    handleDelete(data) {
      this.$confirm(`确定删除${data.name}菜单？`).then(async () => {
        await Services.apiDeleteSystemTree({ id: data.id })
        this.$message.success('删除成功')
        this.handleGetSystemMenu()
      })
    },
  },
};
</script>

<style scoped lang="less">
.tree-wrapper {
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
}
</style>
